const navigateTo = (uri) => window.location.assign(uri);

const navigateToPath = (path) => {
  const { hostname, protocol } = window.location;

  window.location.assign(`${protocol}//${hostname + path}`);
};

export { navigateTo, navigateToPath };
